import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ng-socket-io';

/*
  Generated class for the SocketProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class SocketProvider {


  constructor(
    public http: HttpClient,
    private socket: Socket,
     ) {}


  // startOficinaDigitalNotification(
  //   route:string,
  //   distribuidor: string
  //    ){
  //       this.socket.on(route, (payload)=>{
  //         console.log(" socket with route",payload);
          
  //         this.alertSrv.toastNotification(payload.titulo + ": "+payload.cliente+" - Placa: "+payload.placa );
  //         //new Notification(payload.titulo, { body: "cliente: "+payload.cliente+" placa:"+payload.placa });
  //         // Schedule a single notification


  //       });
  //   this.backgroundMode.enable();
  // }

  disconnect() {
      if (this.socket) {
          this.socket.disconnect();
      }
  }

}


// WEBPACK FOOTER //
// ./src/providers/socket/socket.ts